<template>
  <Transition name="fade">
  <div v-if="!closed" :class="['info-box', type]">
    <div class="info-box-content">
      <slot></slot>
    </div>
    <button
      v-if="closable"
      @click="close"
      class="info-box-close"
      aria-label="Fermer"
    >
      ×
    </button>
  </div>
  </Transition>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'info',
    validator: (value) => ['info', 'success', 'warning', 'error'].includes(value)
  },
  closable: {
    type: Boolean,
    default: true
  },
  open: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:open', 'close'])
const closed = ref(false)

const close = () => {
  emit('update:open', false)
  emit('close')
}
</script>

<style scoped>
.info-box {
  position: relative;
  padding: 1rem;
  border-radius: var(--border-radius-sm);
  /* box-shadow: var(--shadow-md); */
  /* margin: 1rem 2rem; */
  padding: 1.5rem 1.0rem;
  border-left: 4px solid;
}
.info-box-content {
  margin: 0;
}
.info-box-close {
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  line-height: 1;
  opacity: 0.6;
}
.info-box-close:hover {
  opacity: 1;
}
.info-box.info{
  background-color: var(--color-pastel-blue);
  color: var(--color-blue);
}
.info-box.error {
  color: var(--color-burgundy);
  background-color: var(--color-pastel-red);
  border-left-color: var(--color-burgundy);
  /* background-color: var(--color-terracotta); */
}
.info-box.success {
  border-left-color: var(--color-jungle);
  background-color: var(--color-pastel-green);
  color: var(--color-jungle);
}
.info-box.warning {
  background: #fff4e5;
  border-color: #ff9800;
  color: var(--color-text-secondary);
}
.info-box-content {
  margin: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-leave-to {
  opacity: 0;
}

</style>
